// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__1g3U7","title":"style_title__zJtBW","line":"style_line__18bn6","arrow":"style_arrow__2mP3h","sessions":"style_sessions__2sET5","item":"style_item__2NgGX"};